export const weekDays = [
  'lundi',
  'mardi',
  'mercredi',
  'jeudi',
  'vendredi',
  'samedi',
  'dimanche',
];

export interface WeekDay {
  value: number;
  label: string;
}

export enum NewsletterFrequencyEnum {
  weekly = 'weekly',
  week_even = 'week_even',
  week_odd = 'week_odd',
  bi_monthly = 'bi_monthly',
}

export const NewsletterFrequency: Record<NewsletterFrequencyEnum, string> = {
  [NewsletterFrequencyEnum.weekly]: 'Toutes les semaines',
  [NewsletterFrequencyEnum.week_even]: 'Semaines paires',
  [NewsletterFrequencyEnum.week_odd]: 'Semaines impaires',
  [NewsletterFrequencyEnum.bi_monthly]: 'Bi-mensuel',
};
